import './Story.css';
import { useParams, Link } from 'react-router-dom';
import printableList from './printables/printableList.js'
import Footer from './Footer.js';
import React from "react";

function Printable(props) {
    let params = useParams();

    let printableSelected = printableList.find ((printable) =>
    printable.shortName === params.printableShortName)

    if (typeof printableSelected === "undefined") {
        return (
            <div className="notValid">
                <Link className="link" to="/" >
                                <p className="backButton"> back to home </p>
                            </Link>
                <p className="notValidText"> {params.printableShortName} is not a valid story</p>
            </div>
        )
    }
    else 
    return (
        <div className="story">
            <Link className="link" to="/" >
                <p className="backButton"> back to home </p>
            </Link>
            <h1 className="storyHeaderText"> {printableSelected.title}</h1>
            <p className="storyBodyText"> {printableSelected.description} </p>
                        <p className="storyBodyText"> Click the image below to download! </p>
            <a href={printableSelected.src} download={printableSelected.shortName}>
                <img className="storyBodyImage" src={printableSelected.src} alt={printableSelected.alt} />
            </a>
            <img className="storyBodyImage" src={printableSelected.displaySrc} alt={printableSelected.displayAlt} />
        <Footer/>
        </div>

    )

}

export default Printable;